import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export const emptyAgeBand = () => ({
  code: "",
  label: "",
  minAgeDays: "",
  maxAgeDays: "",
  sequence: 0,
});

const AgeBandEditor = ({ value = [], onChange, disabled }) => {
  const bands = Array.isArray(value) ? value : [];

  const update = (index, patch) =>
    onChange(bands.map((band, i) => (i === index ? { ...band, ...patch } : band)));

  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Age Bands
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        Optional. Leave the maximum blank for an open-ended band.
      </Typography>

      {bands.map((band, index) => (
        <Box
          key={index}
          sx={{ display: "flex", gap: 1, alignItems: "flex-start", mb: 1 }}
        >
          <TextField
            size="small"
            label="Code"
            required
            sx={{ minWidth: 130 }}
            value={band.code || ""}
            disabled={disabled}
            onChange={(event) => update(index, { code: event.target.value })}
          />
          <TextField
            size="small"
            label="Label"
            required
            fullWidth
            value={band.label || ""}
            disabled={disabled}
            onChange={(event) => update(index, { label: event.target.value })}
          />
          <TextField
            size="small"
            label="Min age (days)"
            type="number"
            required
            sx={{ minWidth: 150 }}
            value={band.minAgeDays}
            disabled={disabled}
            onChange={(event) =>
              update(index, { minAgeDays: event.target.value })
            }
          />
          <TextField
            size="small"
            label="Max age (days)"
            type="number"
            sx={{ minWidth: 150 }}
            value={band.maxAgeDays}
            disabled={disabled}
            onChange={(event) =>
              update(index, { maxAgeDays: event.target.value })
            }
          />
          <TextField
            size="small"
            label="Seq"
            type="number"
            sx={{ minWidth: 90 }}
            value={band.sequence}
            disabled={disabled}
            onChange={(event) =>
              update(index, { sequence: event.target.value })
            }
          />
          <IconButton
            onClick={() => onChange(bands.filter((_, i) => i !== index))}
            disabled={disabled}
          >
            <DeleteOutlineIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
      ))}

      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={() => onChange([...bands, emptyAgeBand()])}
        disabled={disabled}
      >
        Add band
      </Button>
    </Box>
  );
};

export default AgeBandEditor;
